// import { ACCOUNT_TYPE } from '../utils/constants'

export const sidebarLinks = [
    {
        id: 1,
        name: "My Profile",
        path: '/dashboard/my-profile',
        icon: 'VscAccount',
    },
    {
        id: 2,
        name: "Instructors",
        path: '/dashboard/instructor',
        icon: 'VscProject',
    },
    {
        id: 3,
        name: "My Courses",
        path: '/dashboard/instructor-courses',
        icon: 'VscVm',
    },
    {
        id: 4,
        name: "Add Courses",
        path: '/dashboard/add-courses',
        icon: 'VscAdd',
    },
    {
        id: 5,
        name: "Enrolled Courses",
        path: '/dashboard/enrolled-courses',
        icon: 'VscExtensions',
    },
    {
        id: 6,
        name: "Cart",
        path: '/dashboard/cart',
        icon: 'AiOutlineShoppingCart',
    },
]